<template>
  <b-card no-body :header="title" tag="article" class="mb-2">
    <b-card-text class="p-3 m-0">
      <b-form-file
        drop-placeholder="將檔案拖曳至此"
        browse-text="瀏覽"
        placeholder="尚未選擇檔案"
        accept="image/jpeg, image/png, image/gif"
        :file-name-formatter="formatFilename"
        @input="convertImage"
        multiple
      ></b-form-file>
    </b-card-text>

    <div v-if="files.length === 0">
      <b-card-img :src="waitingImage" alt="Image"></b-card-img>
    </div>
    <b-card-img
      v-for="(file, idx) in files"
      :src="file"
      alt="Image"
      :key="idx"
      bottom
    ></b-card-img>
  </b-card>
</template>

<script>
import waitingImage from '../../assets/image/waiting-image.png';

export default {
  name: 'ImageInput',
  props: {
    title: String,
    maxImages: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      waitingImage,
      files: [],
    };
  },
  methods: {
    async convertImage(files) {
      this.files.length = 0;
      for (const file of files) {
        this.files.push(await this.imageToBase64(file));
      }
      this.files.splice(0, this.files.length - this.maxImages);
      const returnFiles = files.slice(0 - this.maxImages);
      this.$emit('loaded', returnFiles);
    },
    imageToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    formatFilename(files) {
      if (files.length === 1) {
        return files[0].name;
      }
      const length =
        this.files.length > this.maxImages ? this.maxImages : this.files.length;
      return `已選擇 ${length} 張圖片`;
    },
  },
};
</script>
